import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { UserAccountService } from '../../../services/user-account/user-account.service';

@Component({
  selector: 'app-face-search-tabs',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './face-search-tabs.component.html',
  styleUrls: ['./face-search-tabs.component.css'],
})
export class FaceSearchTabsComponent implements OnInit {
  @Input() activeTab: 'reverse-search' | 'face-compare' | 'video-scanner' =
    'reverse-search';
  @Input() showBack = false;
  @Output() back = new EventEmitter<void>();

  private cachedAccessDetails: any = null;
  private cachedSubscriptionDetails: any = null;

  constructor(
    private router: Router,
    private userAccountService: UserAccountService,
  ) {}

  ngOnInit(): void {
    this.loadPortalPermissions();
    this.refreshPermissionsFromProfile();
  }

  private loadPortalPermissions(): void {
    const userPortal = this.readUserPortal();
    this.cachedAccessDetails = userPortal?.accessDetails || null;
    this.cachedSubscriptionDetails = userPortal?.subscriptionDetails || null;
  }

  private refreshPermissionsFromProfile(): void {
    this.userAccountService.getUserProfile().subscribe({
      next: (response) => {
        const subscription = response?.data?.subscriptions?.[0] || {};
        const userPortal = this.readUserPortal();

        const accessDetails = {
          face_search_permission: subscription?.face_search_permission,
          face_compare_permission: subscription?.face_compare_permission,
          video_scanner_permission: subscription?.video_scanner_permission,
          osint_search_permission: subscription?.osint_search_permission,
          leak_search_permission: subscription?.leak_search_permission,
        };

        userPortal.accessDetails = accessDetails;
        userPortal.subscriptionDetails = subscription;
        localStorage.setItem('USER_PORTAL', JSON.stringify(userPortal));

        this.cachedAccessDetails = accessDetails;
        this.cachedSubscriptionDetails = subscription;
      },
      error: () => {},
    });
  }

  private readUserPortal(): any {
    const raw = localStorage.getItem('USER_PORTAL');
    return raw ? JSON.parse(raw) : {};
  }

  get accessDetails(): any {
    return this.cachedAccessDetails;
  }

  get subscriptionDetails(): any {
    return this.cachedSubscriptionDetails;
  }

  hasFaceSearchPermission(): boolean {
    return Boolean(
      this.accessDetails?.face_search_permission ||
        this.subscriptionDetails?.face_search_permission,
    );
  }

  hasFaceComparePermission(): boolean {
    return Boolean(
      this.accessDetails?.face_compare_permission ||
        this.subscriptionDetails?.face_compare_permission,
    );
  }

  hasVideoScannerPermission(): boolean {
    return Boolean(
      this.accessDetails?.video_scanner_permission ||
        this.subscriptionDetails?.video_scanner_permission,
    );
  }

  onBackClick(): void {
    this.back.emit();
  }

  navigate(tab: 'reverse-search' | 'face-compare' | 'video-scanner'): void {
    switch (tab) {
      case 'reverse-search':
        this.router.navigate(['/osint-image-search']);
        break;
      case 'face-compare':
        this.router.navigate(['/osint-image-search/face-compare']);
        break;
      case 'video-scanner':
        this.router.navigate(['/osint-image-search/video-scanner']);
        break;
    }
  }
}
